<template>
  <page-widget>
    <template v-slot:heading>
      <slot name="heading"></slot>
    </template>
    <template v-slot:body>
      <div class="row mb-20">
        <div class="col-xs-7 col-sm-12 col-md-8">
          <slot name="info"></slot>
        </div>
        <div class="col-12 col-xs-5 col-sm-7 col-md-4 text-center">
          <slot name="controls"></slot>
        </div>
      </div>
    </template>
  </page-widget>
</template>

<script>
  import PageWidget from '@/components/PageWidget.vue'

  export default {
    components: {
      PageWidget
    }
  }
</script>